import camelCase from 'camel-case'
import snakeCase from 'snake-case'

type SnakeCaseObject = {
  [key: string]: any
}

type CamelCaseObject = {
  [key: string]: any
}

export function convertKeysToCamelCase(obj: SnakeCaseObject): CamelCaseObject {
  if (!obj || Object.keys(obj)?.length === 0) return obj

  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => {
      return [camelCase(key), value]
    })
  )
}

export function convertKeysToSnakeCase(obj: CamelCaseObject): SnakeCaseObject {
  if (!obj || Object.keys(obj)?.length === 0) return obj

  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => {
      return [snakeCase(key), value]
    })
  )
}
